<h2 mat-dialog-title>{{ "multipleImagesEditDialog.title" | translate }}</h2>
@if (canEditInspection()) {
  <mat-dialog-content class="batch-property-div">
    <!--mark-->
    <mat-form-field>
      <mat-label>{{ markLabel }}</mat-label>
      <mat-select hideSingleSelectionIndicator [formControl]="markControl">
        <mat-select-trigger>
          @if (markControl.value !== null) {
            <ng-container>
              <div class="inspection-data-mark-entry">
                <span
                  class="inspection-data-mark-color-icon"
                  [style.background-color]="marks && 0 < marks.length && getMarkById(markControl.value)?.color"
                  >{{ getMarkById(markControl.value)?.code }}</span
                >
                <span class="inspection-data-mark-entry-label">{{ marks && 0 < marks.length ? getMarkById(markControl.value).label : "" }}</span>
              </div>
            </ng-container>
          }
        </mat-select-trigger>
        <mat-option>{{ "multipleImagesEditDialog.noChange" | translate }}</mat-option>
        @for (mark of marks; track mark.identifier) {
          @if (mark.color !== MARK_DISABLED_COLOR) {
            <mat-option [value]="mark.identifier">
              <div class="inspection-data-mark-entry">
                <span class="inspection-data-mark-color-icon" [style.background-color]="mark.color">{{ mark.code }}</span>
                &nbsp;
                <span class="inspection-data-mark-entry-label">{{ mark.label }}</span>
              </div>
            </mat-option>
          }
        }
      </mat-select>
    </mat-form-field>

    <app-search-combo-box [options]="titleOptions" [placeholder]="titleLabel" (changedValue)="onTitleChange($event)"> </app-search-combo-box>
    <!--tag-->
    <mat-form-field *ngIf="isShowTags" class="clear-button">
      <mat-label>{{ tagsLabel }}</mat-label>
      <mat-select hideSingleSelectionIndicator multiple [formControl]="tagsControl">
        <mat-option [value]="tag" *ngFor="let tag of tags">
          {{ tag }}
        </mat-option>
      </mat-select>
      <mat-hint align="start">
        <mat-checkbox [(ngModel)]="isTagsClear" (change)="changeTagsDisable()">
          {{ "multipleImagesEditDialog.clear" | translate }}
        </mat-checkbox>
      </mat-hint>
    </mat-form-field>
    <div *ngIf="isShowTags" fxFlex class="clear-button"></div>
    <!--comment-->
    <mat-form-field class="comment-form" style="padding-top: 10px">
      <mat-label>{{ "multipleImagesEditDialog.commentPlaceholder" | translate }}</mat-label>
      <input matInput maxlength="{{ commentMaxLength }}" [formControl]="commentControl" style="width: 100%" />
      <mat-hint align="start">
        <mat-checkbox [(ngModel)]="isCommentClear" (change)="changeCommentDisable()"
          >{{ "multipleImagesEditDialog.clear" | translate }}
        </mat-checkbox>
      </mat-hint>
      <mat-hint align="end" *ngIf="!isCommentClear"> {{ commentControl.value?.length || 0 }}/{{ commentMaxLength }} </mat-hint>
      <mat-error *ngIf="commentControl.hasError('maxlength')">{{
        "multipleImagesEditDialog.commentMaxLengthError" | translate: { commentMaxLength: commentMaxLength }
      }}</mat-error>
    </mat-form-field>
    <div fxFlex></div>
    <div fxLayout="row" fxLayoutAlign="start" fxFlex="1 1" class="selected-count">
      {{ "multipleImagesEditDialog.selectedImageAndVideo" | translate: { images: getSelectedImageCount(), videos: getSelectedVideoCount() } }}
    </div>
    <mat-dialog-actions class="button-div">
      <div class="button-sub-div" fxFlex fxLayout="row" fxLayoutAlign="start">
        <button class="close-button" mat-button (click)="close()" color="primary">{{ "multipleImagesEditDialog.close" | translate }}</button>
        <button mat-raised-button color="primary" (click)="imagePropertyMultipleUpdate()" [disabled]="checkNoChange() || isProcessing">
          {{ "multipleImagesEditDialog.save" | translate }}
        </button>
      </div>
      <div class="button-sub-div" fxLayoutAlign="end">
        <button class="attribute-button" mat-raised-button color="warn" (click)="openMultipleDeleteDialog()" [disabled]="isProcessing">
          {{ "multipleImagesEditDialog.delete" | translate }}
        </button>
      </div>
    </mat-dialog-actions>
  </mat-dialog-content>
}
